export const FIND_POOL_REQUEST_REQUEST = 'FIND_POOL_REQUEST_REQUEST';

export const findPoolRequestRequest = ( id ) => ({
    type: FIND_POOL_REQUEST_REQUEST,
    payload: { id }
});
